import { createAsyncThunk } from '@reduxjs/toolkit';

import AuthApi from 'api/auth/AuthApi';
import { VerifyEmailVerificationCodeRequest } from 'api/auth/authApi.types';

export const otpVerifyThunk = (authApi: AuthApi) =>
  createAsyncThunk('otp/Login', async (request: VerifyEmailVerificationCodeRequest, {}) => {
    const response = await authApi.verifyOtpCode(request);

    localStorage.setItem('token', response.accessToken);
    localStorage.setItem('refreshToken', response.refreshToken);

    return response;
  });
